export const STORAGE = {
  SELECTED_VARIANT: 'selected_variant_',
  CUSTOMISED_CAR: 'customised_car_',
  CUSTOMER_DATA: 'customer_data_',
  GRAPHQL_LOCAL_STORAGE: 'spcGqlApi',
  SOFT_LOCKED: 'softLocked',
};
